export const STORE_PROJECT_ASSIGNMENT = 'ProjectAssignment';

export const STORE_GLOBAL_ADMINISTRATION = 'GlobalAdministration';

export const STORE_CODE_SNIPPETS_UI = 'CodeSnippetsUI';

export const STORE_USERS_MANAGER_UI = 'UsersManager';

export const STORE_TECHNICAL_INFORMATION = 'TechnicalInformation';

export const STORE_ML_MODELS_MANAGEMENT = 'MlModelsManagement';

export const STORE_HOME_SHORTCUTS = 'HomeShortcuts';

export const STORE_API_KEYS = 'ApiKeys';
